export default __webpack_public_path__ + "static/media/HEAVY OBJECT LIFITING TRAINING SIMULATOR WITH ELECTRICAL.2b6588da.JPG";